import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { RootState } from '../../modules';
import {
  BidProposalParams,
  createBidProposalAsync,
} from '../../modules/bid-chances';
import BidProposalCreateSimpleComponent from '../../components/bid-chances/BidProposalCreateSimpleComponent';
import {
  getBidProposalFileAPIPath,
  initializeUploadProps,
} from '../../util/utils';

interface BidProposalCreateContainerProps {
  bidChanceId: string;
}
function BidProposalCreateContainer({
  match,
  history,
}: RouteComponentProps<BidProposalCreateContainerProps>) {
  const { bidChanceId } = match.params;
  const bidChance = useSelector(
    (state: RootState) => state.bidChances.bidChance.data,
  );
  const [uploadProps, setUploadProps] = useState<any>();
  const dispatch = useDispatch();
  useEffect(() => {
    if (bidChance) {
      (async () => {
        setUploadProps(
          await initializeUploadProps(getBidProposalFileAPIPath(bidChanceId)),
        );
      })();
    }
  }, [bidChanceId, bidChance]);

  const onFinish = (data: any) => {
    const bidProposalParams: BidProposalParams = {
      bidChanceId,
      bidProposal: {
        ...data,
        bidProposalLineItems: [],
      },
    };
    if (bidProposalParams.bidProposal?.file) {
      for (const _file of bidProposalParams.bidProposal.file) {
        if ('response' in _file) {
          _file.path = _file.response.path;
          _file.mimeType = _file.response.mimeType;
        }
      }
    }

    dispatch(createBidProposalAsync.request(bidProposalParams));
    history.goBack();
  };

  const onCancel = () => {
    history.goBack();
  };

  return (
    <>
      {!bidChance?.bidder.bidPackage?.isSovIncluded && (
        <BidProposalCreateSimpleComponent
          uploadProps={uploadProps}
          onFinish={onFinish}
          onCancel={onCancel}
        />
      )}
    </>
  );
}

export default BidProposalCreateContainer;
